module.exports = __webpack_public_path__ + "img/IconsetW.93f28913.png";